import { Timezone } from "../../TimezoneList/TimezoneList";

type TimezonesByContinent = { continent: string; timezones: Timezone[] };

export const getTimezonesGroupedByContinent = (
  timezoneSearchText: string,
  timezones: Timezone[]
) => {
  const escapeRegexp = (value: string): string =>
    value.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");

  const showItem = (searchText: string, timezone: string): boolean => {
    return !!timezone
      .toString()
      .match(new RegExp(escapeRegexp(searchText), "i"));
  };

  const continents = [...new Set(timezones.map(({ continent }) => continent))];

  const timezonesByContinent: TimezonesByContinent[] = [];

  continents.forEach((continent: string) => {
    const searchMatchesContinent =
      !timezoneSearchText || showItem(timezoneSearchText, continent);

    if (searchMatchesContinent) {
      timezonesByContinent.push({
        continent,
        timezones: timezones.filter(
          (timezone) => timezone.continent === continent
        ),
      });
    } else {
      const continentTimezones = timezones.filter((timezone) => {
        const showTimezoneItem =
          !timezoneSearchText || showItem(timezoneSearchText, timezone.name);
        return timezone.continent === continent && showTimezoneItem;
      });

      if (continentTimezones.length > 0) {
        timezonesByContinent.push({
          continent,
          timezones: continentTimezones,
        });
      }
    }
  });

  return timezonesByContinent;
};
